var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRelationsIcon = function SvgRelationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-11{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-22{fill:none;stroke:#1a4880;stroke-width:4px;}.cls-22{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 2,
    y: 10,
    width: 22,
    height: 22,
    rx: 2.53,
    ry: 2.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M24.5,21.5l21.6-.16M46.1,21.34l-7.62-7.62M46.1,21.34l-7.62,7.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 53,
    y: 2,
    width: 36,
    height: 36,
    rx: 2.53,
    ry: 2.53
  }))));
};
export default SvgRelationsIcon;